import React, { useMemo } from 'react';
import { IconFlag } from 'components';
import { SingleClientTaskRow } from './singleClientTaskRow';
import { formatDate } from 'utils/helpers';

export const ClientTasks = ({ client }) => {
  const storeTasks = useMemo(() => {
    const lastAssignedTask = [...(client?.tasks || [])].filter((t) => t.assigned_at).at(-1);
    const lastAssignedWeek = lastAssignedTask?.week ?? 0;
    const lastAssignedAt = lastAssignedTask?.assigned_at ?? null;

    const normalizedTasks = Array.from({ length: 6 }, (_, index) => {
      return (
        client?.tasks?.[index] ?? {
          completed: false,
          week: index + 1,
          task_id: null,
          form_id: null,
        }
      );
    });

    return normalizedTasks.map((task, index) => {
      return (
        <SingleClientTaskRow
          key={task.task_id || `week-${index + 1}`}
          weekIndex={index + 1}
          task={task}
          startDate={client.start_date}
          clientStatus={client.status}
          lastAssignedWeek={lastAssignedWeek}
          lastAssignedAt={lastAssignedAt}
          granted={client.granted[index]}
        />
      );
    });
  }, [client.granted, client.start_date, client.status, client.tasks]);

  return (
    client && (
      <div className="flex flex-col bg-white base-block rounded-block-radius md:rounded-[24px] mt-6 md:mt-4">
        <div className='flex flex-row md:flex-col justify-between items-center md:items-start p-[30px] md:p-4 gap-y-3 relative border-b border-divider w-full after:content-[""] after:absolute after:w-4 after:h-4 after:rounded-full after:border after:border-divider after:bg-white after:z-10 after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:translate-y-1/2'>
          <p className="nunito-title text-22 md:text-16">Your Tasks</p>
          <div className="flex items-center gap-x-12 md:gap-x-2 md:w-full md:justify-between">
            <div className="flex items-center bg-white p-1 pl-2.5 rounded-ten shadow-block-shadow-light">
              <IconFlag className="w-3.5 h-3.5 md:w-4 md:h-4" color="#000" />
              <p className="text-14 md:text-11 ml-1.5 mr-2.5 md:mr-1.5 font-medium">Start</p>
              <div className="flex items-center bg-[#FFF3D7] py-1.5 md:py-1 px-3 md:px-2 rounded-md">
                <p className="text-14 md:text-11 font-bold text-[#8A5B00]">{formatDate(client?.start_date)}</p>
              </div>
            </div>
            <div className="flex items-center bg-white p-1 pl-2.5 rounded-ten shadow-block-shadow-light">
              <IconFlag className="w-3.5 h-3.5 md:w-4 md:h-4" color="#000" />
              <p className="text-14 md:text-11 ml-1.5 mr-2.5 md:mr-1.5 font-medium">End</p>
              <div className="flex items-center bg-lightGreen py-1.5 md:py-1 px-3 md:px-2 rounded-md">
                <p className="text-14 md:text-11 font-bold text-darkGreen">{formatDate(client.end_date)}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col py-5 md:py-4 px-[30px] md:px-3 gap-y-4 md:gap-y-2.5">
          {/* Table Header (shown on Desktop, hidden on Mobile) */}
          <div className="flex md:hidden items-center">
            <p className="text-lightBlue text-14 w-[20%]">Week</p>
            <div className="w-4/5 flex items-center px-4 gap-x-8">
              <p className="w-1/4 text-lightBlue text-14">Forms</p>
              <p className="w-1/4 text-lightBlue text-14">Granted</p>
              <p className="w-1/4 text-lightBlue text-14">Assigned</p>
              <p className="w-1/4 text-lightBlue text-14">Status</p>
              <p className="w-1/4 text-lightBlue text-14" />
            </div>
          </div>
          {storeTasks}
          <div className="mt-4 flex flex-wrap items-center gap-x-6 md:gap-x-4 justify-end md:justify-center pb-4 md:pb-2 gap-y-2">
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-green" />
              <p className="text-14 md:text-11">Completed</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-orange" />
              <p className="text-14 md:text-11">Pending</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-red" />
              <p className="text-14 md:text-11">Overdue</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-grey ring-2 ring-orange" />
              <p className="text-14 md:text-11">Current</p>
            </div>
            <div className="flex items-center gap-x-2">
              <div className="w-3 h-3 rounded-full bg-grey" />
              <p className="text-14 md:text-11">Upcoming</p>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
